// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../getOverlappingDaysInIntervals/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var getOverlappingDaysInIntervals = convertToFP(fn, 2);
export default getOverlappingDaysInIntervals;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/getOverlappingDaysInIntervals/index.js
// module id = 903
// module chunks = 0